module.exports = __webpack_public_path__ + "img/MiTale-color-Logo.8c8c8447.png";